var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAgreement = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19809"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19802",
  transform: "translate(-40 -449.719)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  "data-name": "Ellipse 1641",
  transform: "translate(40 449.719)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 19771",
  transform: "translate(52.381 459.625)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.25 18.615H2.017A2.017 2.017 0 0 1 0 16.594l.007-3.055V2.017A2.017 2.017 0 0 1 2.024 0h11.2a2.017 2.017 0 0 1 2.017 2.017v14.581a2.017 2.017 0 0 1-2.017 2.017h-.6",
  "data-name": "Path 27423"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.38 4h8.461",
  "data-name": "Line 1706"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.841 7.384H3.38",
  "data-name": "Line 1707"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.623,
  cy: 2.623,
  r: 2.623,
  "data-name": "Ellipse 1642",
  transform: "translate(7.527 10.063)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.044 14.575v5.541l-1.86-1.864-1.929 1.933v-5.541",
  "data-name": "Path 27424"
}))))));
export { SvgAgreement as ReactComponent };
export default __webpack_public_path__ + "static/media/agreement.af1e1ca1e0f549749877060da0b74b64.svg";